export const CHECKOUT_URL = 'https://kids-learning-ready.impultienda.ar/checkout'

export const BUY_ANCHOR = 'buy'

export const PRODUCT_NAME = 'KIDS LEARNING READY™'

export const CTA_LABEL = 'GET KIDS LEARNING READY™ NOW'

export function scrollToBuy(): void {
  const el = document.getElementById(BUY_ANCHOR)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export const IMAGES = {
  boxSet:
    'https://cdn.magicpatterns.com/uploads/btRjbfwJDBmUZEQ6L9tQyB/Diseno-sin-titulo-4.webp',
}
